"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.takeoffSections = takeoffSections;
const surfaces_ts_1 = require("./surfaces.js");
const text = (value) => (typeof value === 'string' ? value.trim() : '');
/** "Unit × 12" for a count above one, else the name alone. */
const times = (name, count) => (count > 1 ? `${name} × ${count}` : name);
/**
 * `sections` and `info` are toSections' (the priced option), `areas` the
 * measure's area records. An area whose surfaces can't be read keeps its
 * name; its rows' types fall back to their own names.
 */
function takeoffSections(sections, info, areas) {
    const severalBuildings = new Set([...info.values()].map((i) => i.building)).size > 1;
    const records = new Map(areas.map((a) => [a.id, a]));
    return sections.map((input) => {
        const about = info.get(input.id);
        const fields = records.get(input.id)?.fields ?? {};
        let doc;
        try {
            doc = (0, surfaces_ts_1.parseSurfaces)(fields.hig_surfaces);
        }
        catch {
            doc = { surfaces: [], groups: [] };
        }
        const area = severalBuildings && about?.building ? `${about.building} – ${input.name}` : input.name;
        const groupsUsed = doc.groups.filter((g) => input.surfaces.some((s) => doc.surfaces.find((m) => m.id === s.id)?.groupId === g.id));
        const name = [times(area, about?.count ?? 1), ...groupsUsed.map((g) => times(g.name, g.count))].join(' – ');
        return {
            input,
            side: about?.side === 'External' ? 'External' : 'Internal',
            name,
            typeNames: Object.fromEntries(doc.surfaces.map((s) => [s.id, s.typeName])),
            exclusions: text(fields.hig_exclusions) || null,
            notes: text(fields.hig_scopenotes) || null,
        };
    });
}
